module.exports = __webpack_public_path__ + "static/img/environment.95418c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/environment.png
// module id = GxjS
// module chunks = 1